import { render } from "./AddProduitConditionnement.vue?vue&type=template&id=567196a4&scoped=true&ts=true"
import script from "./AddProduitConditionnement.vue?vue&type=script&lang=ts"
export * from "./AddProduitConditionnement.vue?vue&type=script&lang=ts"

import "./AddProduitConditionnement.vue?vue&type=style&index=0&id=567196a4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-567196a4"]])

export default __exports__